import * as React from 'react';
import {Select} from '@mui/material';
import { MenuItem } from '@mui/material';
import { InputLabel } from '@mui/material';
import { FormControl, FormHelperText } from '@mui/material';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import {Switch} from '@mui/material';
import { FormControlLabel, FormGroup } from '@mui/material';


const styles = (theme:Theme):StyleRules => ({
    container: {
      width: "100%" 
    },
    yesNo: {
        width: 100
    }
  })

  interface Props extends React.HTMLProps<HTMLDivElement> {
    presentAs: "Select" | "Routes"
    onBooleanChange: (event: any) => void;
    handleBlur?: (event: any) => void;
    className?: string
    required: boolean
    disabled?: boolean
    error?: boolean
    label: string,
    classes: any,
    helperText?: string, 
    value:any,
    color?: "inherit" | "primary" | "secondary" | undefined;
}

type State = {
	value: boolean  | null;
};

class BooleanField extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props) {
        super(props, {});
        var val:boolean | null = null;
        if(props.value !== undefined && props.value !== null && props.value !== -1 ) {
			val = props.value == 1 ? true : false
        }
		this.state = {
            value: val
		};
    };

	onSelectChange = (event: any) => {
        var val:boolean | null 
        switch (event.target.value) {
            case 0:
                val = false
                break;
        
            case 1:
                val = true
                break;

            default:
                val = null
                break;
        }

        this.setState({value: val}, ()=>{
            this.props.onBooleanChange(event)
        })                

    };

    onSwitchChange = (event: any) => {
        var e = {target:{value:event.target.checked}}
        if (e.target.value != this.state.value) {
            this.setState({value:event.target.checked}, ()=>{
                this.props.onBooleanChange(e)
            })
       }

    }
    
	render() {
        const { classes }: { classes:ClassNameMap } = this.props
		const {
            className,
			error,
			label,
			required,
            presentAs,
            helperText,
            color
		} = this.props;
        const { value } = this.state;
                
        var val:number | undefined = -1 
        if(value != undefined) {
            val=value == true ? 1 : 0
        }
        
        switch (presentAs) {
            case "Switch":
                return (
                    <FormGroup >
                        <FormControlLabel
                            control={<Switch color={color || "primary"} checked={value ? true : false} onChange={this.onSwitchChange} disabled={this.props.disabled} />}
                            label={label}
                        >
                        </FormControlLabel>
                        <FormHelperText>{helperText}</FormHelperText>
                    </FormGroup> 
                )
            default:

                return (
                    <FormControl className={className}>
                    <InputLabel required={required}>{label}</InputLabel>
                    <Select
                        className={classes.yesNo}
                        value={val}
                        onChange={this.onSelectChange}
                        classes={{}}
                        error={error}
                        disabled={this.props.disabled}
                    >
                        <MenuItem value={-1}></MenuItem>
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={0}>No</MenuItem>
                    </Select>
                    <FormHelperText>{helperText}</FormHelperText>
                </FormControl>
                )
        }

	}
}

export default withStyles(styles)(BooleanField);
